const renderSection = async (section, handle, targetEl, type) => {
  await fetch(
    window.Shopify.routes.root + `${type}/${handle}?sections=${section}`
  ).then((res) => res.json()).then((result) => {
    console.log({
      "section rendering api result": result,
      targetEl,
      html: result[section],
      "target el": document.querySelector(targetEl)
    });
    let count = 0;
    count++;
    console.log(document.querySelector(targetEl), count);
    document.querySelector(targetEl).innerHTML = result[section];
    const detail = {
      element: targetEl
    };
    document.dispatchEvent(new CustomEvent("section:rendered", { detail }));
  });
};
async function cartDrawerUpsell() {
  const drawerSuggestedProductsWrapper = document.querySelector(
    `#drawer-complimentary-products`
  );
  if (!drawerSuggestedProductsWrapper)
    return;
  const mostExpensiveProductHandle = drawerSuggestedProductsWrapper.dataset.mostExpensiveItemHandle;
  if (!mostExpensiveProductHandle)
    return;
  await renderSection(
    "cart-drawer-complimentary-products",
    mostExpensiveProductHandle,
    `#drawer-complimentary-products`,
    "products"
  );
}
window.addEventListener("DOMContentLoaded", async (event) => {
  cartDrawerUpsell();
  document.addEventListener("cart-drawer:rendered", async function() {
    console.log("!!!!!!!!!!! - cart rendered");
    await cartDrawerUpsell();
  });
});
